export const PERIOD_FILTER_OPTIONS = [
  ["all", "All"],
  ["daily", "Daily"],
  ["weekly", "Weekly"],
  ["monthly", "Monthly"],
];

export const PeriodFilter = ({ activePeriod, onChange, testPrefix, className = "" }) => (
  <div className={`flex rounded-full border border-[#E5E1D8] bg-white p-1 ${className}`} data-testid={`${testPrefix}-period-filter`}>
    {PERIOD_FILTER_OPTIONS.map(([value, label]) => (
      <button
        key={value}
        type="button"
        onClick={() => onChange(value)}
        data-testid={`${testPrefix}-period-${value}-button`}
        className={`flex-1 rounded-full px-4 py-2 text-sm font-medium transition-[background-color,color] duration-300 sm:flex-none ${activePeriod === value ? "bg-[#C87961] text-white" : "text-[#4A5D4E] hover:bg-[#F9F6F0]"}`}
      >
        {label}
      </button>
    ))}
  </div>
);